export type DashboardReskinTileState = 'launch' | 'locked' | 'replay'

export const DASHBOARD_RESKIN_TILE_SIZE_CLASS = 'h-[448px] w-[326px]'
export const DASHBOARD_RESKIN_LAUNCH_TILE_SIZE_CLASS = 'h-[494px] w-[371px]'

export const getDashboardReskinTileSizeClass = (
  state: DashboardReskinTileState
): string => state === 'launch'
  ? DASHBOARD_RESKIN_LAUNCH_TILE_SIZE_CLASS
  : DASHBOARD_RESKIN_TILE_SIZE_CLASS

const DASHBOARD_RESKIN_DIR = '/assets/images/dashboard-reskin'

interface DashboardReskinTileSet {
  launch?: string
  replay?: string
  locked?: Partial<Record<number, string>>
}

export const dashboardReskinTiles: Record<string, DashboardReskinTileSet> = {
  cocaine: {
    launch: `${DASHBOARD_RESKIN_DIR}/Level1 - LAUNCH.svg`,
    replay: `${DASHBOARD_RESKIN_DIR}/Level1 - REPLAY.svg`
  },
  xanax: {
    launch: `${DASHBOARD_RESKIN_DIR}/Level2 - LAUNCH.svg`,
    replay: `${DASHBOARD_RESKIN_DIR}/Level2 - REPLAY.svg`,
    locked: {
      1: `${DASHBOARD_RESKIN_DIR}/Level2 - LOCKED 1.svg`
    }
  },
  mdma: {
    launch: `${DASHBOARD_RESKIN_DIR}/Level3 - LAUNCH.svg`,
    replay: `${DASHBOARD_RESKIN_DIR}/Level3 - REPLAY.svg`,
    locked: {
      1: `${DASHBOARD_RESKIN_DIR}/Level3 - LOCKED 1.svg`,
      2: `${DASHBOARD_RESKIN_DIR}/Level3 - LOCKED 2.svg`
    }
  },
  response: {
    launch: `${DASHBOARD_RESKIN_DIR}/Level4 - LAUNCH.svg`,
    replay: `${DASHBOARD_RESKIN_DIR}/Level4 - REPLAY.svg`,
    locked: {
      1: `${DASHBOARD_RESKIN_DIR}/Level4 - LOCKED 1.svg`,
      2: `${DASHBOARD_RESKIN_DIR}/Level4 - LOCKED 2.svg`,
      3: `${DASHBOARD_RESKIN_DIR}/Level4 - LOCKED 3.svg`
    }
  }
}

export const getDashboardReskinTileState = (
  module: { isCurrent?: boolean, isLocked?: boolean },
  reviewState: boolean
): DashboardReskinTileState => {
  if (reviewState) {
    return 'replay'
  }
  if (module.isCurrent === true) {
    return 'launch'
  }
  if (module.isLocked === true) {
    return 'locked'
  }
  return 'replay'
}

export const getDashboardReskinLockedIteration = (currentModuleIndex: number): number => {
  if (currentModuleIndex < 0) {
    return 1
  }
  return currentModuleIndex + 1
}

export const getDashboardReskinTileSrc = (
  moduleName: string,
  state: DashboardReskinTileState,
  lockedIteration: number = 1
): string | undefined => {
  const tiles = dashboardReskinTiles[moduleName.toLowerCase()]
  if (tiles == null) {
    return undefined
  }

  const src = state === 'locked'
    ? tiles.locked?.[lockedIteration]
    : tiles[state]
  if (src == null) {
    return undefined
  }
  return encodeURI(src)
}
